import React from 'react';
import styles from './AttributesSelector.module.scss';
import AttributeLine from './AttributeLine';
import { Button, LightTableContainer } from 'components';

// export interface Attribute {
//   type: string;
//   values: string[];
//   isOpt: boolean;
// }

// interface State {
//   attributes: Attribute[];
// }

const emptyAttribute = {
  name: '',
  type: '',
  values: [],
  opt: false
};

const AttributesSelector = props => {
  const { attributes, setAttributes } = props;

  const handleAttributeChange = (index: number, action: 'delete' | 'change', attr = null) => {
    const cloneAttributes = [...attributes];

    action === 'delete'
      ? cloneAttributes.splice(index, 1)
      : cloneAttributes[index] = attr;

    setAttributes(cloneAttributes);
  };

  const canGenerateSkus = () => {
    let result = true;
    attributes.forEach(({ values }) => {
      if (result && !values.length) {
        result = false;
      }
    });
    return result;
  };

  return (
      <LightTableContainer title='Product Attributes'>

      {attributes.map((attribute, index) =>
        <AttributeLine
          key={index}
          attribute={attribute}
          setAttribute={attr => handleAttributeChange(index, 'change', attr)}
          deleteLine={() => handleAttributeChange(index, 'delete')}
        />
      )}

      <div className={styles.buttonsContainer}>
        <Button
          size='small'
          type='add'
          onClick={() => setAttributes([...attributes, emptyAttribute])}
        >
          add attribute
        </Button>

        <Button
          size='small'
          type='submit'
          disabled={!canGenerateSkus()}
        >
          generate skus
        </Button>
      </div>

    </LightTableContainer>
  );
};

export default AttributesSelector;
